<aside
   class="lm-overlay-container"
   [style.width.px]="currentWidth()"
   [style.min-width.px]="currentMinWidth()"
   [style.max-width.px]="currentMaxWidth()"
   soho-busyindicator
   [displayDelay]="10">
  <ng-template #dynamic></ng-template>
  <div
    class="splitter"
    [style.width.px]="5"
    cdkDrag
    (cdkDragMoved)="onDragMoved($event)"
    (mouseenter)="onOffSet($event)"
    (mousemove)="onOffSet($event)" >
    <div class="splitter-drag-handle" [style.top.px]="currentMouseOffset()"></div>
  </div>
</aside>
